import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/utils/fonts.ts\",\"import\":\"Sen\",\"arguments\":[{\"subsets\":[\"latin\",\"latin-ext\"],\"variable\":\"--font-family-sen\",\"display\":\"swap\"}],\"variableName\":\"sen\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/utils/fonts.ts\",\"import\":\"Noto_Sans\",\"arguments\":[{\"subsets\":[\"cyrillic\",\"cyrillic-ext\",\"devanagari\",\"greek\",\"greek-ext\",\"latin\",\"latin-ext\",\"vietnamese\"],\"variable\":\"--font-family-noto\",\"display\":\"swap\"}],\"variableName\":\"noto\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/utils/fonts.ts\",\"import\":\"Be_Vietnam_Pro\",\"arguments\":[{\"subsets\":[\"vietnamese\"],\"display\":\"swap\",\"weight\":[\"400\",\"500\",\"600\",\"700\",\"800\"],\"variable\":\"--font-vietnam\"}],\"variableName\":\"bVietnamPro\"}");
;
import(/* webpackMode: "eager", webpackExports: ["fetchAutocompleteResults"] */ "/app/src/app/api/search.ts");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/blog/BlogNewsletterSignupWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/CookieBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/FooterNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/Header.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/styles/globals.css");
